import { Box, BoxProps } from '@mui/material';
import React from 'react';

/*
 * An image that fit the parent size
 */
interface ImageFluidHorizontallyConstrainedProps extends BoxProps {
  width: string | number;
}

interface ImageFluidVerticallyConstrainedProps extends BoxProps {
  height: string | number;
}

type ImageFluidProps = {
  src: string;
  alt: string;
} & (ImageFluidHorizontallyConstrainedProps | ImageFluidVerticallyConstrainedProps);

function ImageFluid({ src, alt = null, height = null, width = null, ...props }: ImageFluidProps) {
  return (
    <Box height={height} width={width} {...props}>
      <Box component="img" sx={height ? { maxHeight: '100%', width: 'auto' } : { maxWidth: '100%', height: 'auto' }} src={src} alt={alt} />
    </Box>
  );
}

export default ImageFluid;
